export function canAccessFeature(userData, feature) {
  return (userData?.accessibleFeatures || []).includes(feature);
}
